export default __webpack_public_path__ + "static/media/bean_bag.708b63df.png";